import {FETCH_IMAGES_AND_USER_SUCCESS} from '../actions/ImageActions';
import {
    USER_FETCH_FAILURE, USER_FETCH_REQUEST, USER_FETCH_SUCCESS, USER_DELETE_SUCCESS, USERS_FETCH_FAILURE, USERS_FETCH_REQUEST,
    USERS_FETCH_SUCCESS
} from '../actions/UserActions';
import omit from 'lodash/omit';
import keyBy from 'lodash/keyBy';
import isEmpty from 'lodash/isEmpty';
import {USER_SET_PREFERRED_SUCCESS} from '../actions/PresetActions';
import {createSelector} from 'reselect';
import {getUserId} from './openImage';

export const usersReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_FETCH_REQUEST: {
            const {id} = action;
            return {...state, [id]: {...state[id], loading: true, error: null}};
        }
        case USER_FETCH_FAILURE: {
            const {id, error} = action;
            return {...state, [id]: {...state[id], loading: false, error}};
        }
        case USER_FETCH_SUCCESS:
        case FETCH_IMAGES_AND_USER_SUCCESS: {
            const {user} = action;
            return {...state, [user.id]: user};
        }
        case USER_DELETE_SUCCESS: {
            const {id} = action;
            return omit(state, id);
        }
        case USERS_FETCH_REQUEST: {
            return {...state, loading: true};
        }
        case USERS_FETCH_FAILURE: {
            const {error} = action;
            return {...state, loading: false, error};
        }
        case USERS_FETCH_SUCCESS: {
            const {users} = action;
            return keyBy(users, 'id');
        }
        case USER_SET_PREFERRED_SUCCESS:
            const {id, amplitude, spread} = action;
            return {...state, [id]: {...state[id], preferredAmplitude: amplitude, preferredSpread: spread}};
        default:
            break;
    }
    return state;
};

export const getUsers = state => state.users;

export const getUser = createSelector(
    [getUserId, getUsers],
    (userId, users) => {
        return userId && !isEmpty(users) ? users[userId] : null;
    }
);

export const getImagesFetchStatus = state => state.imagesFetchStatus;

export const getFetchStatus = createSelector(
    [getUserId, getImagesFetchStatus],
    (userId, imagesFetchStatus) => {
        return userId && !isEmpty(imagesFetchStatus) ? imagesFetchStatus[userId] : {};
    }
);



// WEBPACK FOOTER //
// ./src/reducers/users.js